<template>
  <div :key="form.type" class="content">
    <div class="my-bank-card">
      <div class="my-form-input">
        <div class="form-input">
          <label>{{ $t('Bao.add_card_type') }}：</label>
          <div class="form-select-2">
            <input
              ref="inputField"
              readonly=""
              class="select"
              type="text"
              :placeholder="selectedType"
              @click="toggleCardType"
            >
            <ul ref="dropdown" class="select-box" :class="{ active: isShowType }">
              <li :class="{ active: form.type === 1 }" @click="clickSelectType(1)">
                {{ $t('Bao.card') }}
              </li>
              <li :class="{ active: form.type === 2 }" @click="clickSelectType(2)">
                {{ $t('Bao.e_wallet') }}
              </li>
              <li :class="{ active: form.type === 3 }" @click="clickSelectType(3)">
                {{ $t('Bao.cryptocurrency') }}
              </li>
              <!-- <li :class="{ active: form.type === 4 }" @click="clickSelectType(4)">
                {{ $t('Bao.credit_card') }}
              </li> -->
            </ul>
          </div>
        </div>
        <template v-if="form.type === 4">
          <div class="row-half">
            <div
              class="form-input inp-left"
              :class="{ 'form-input-error-1': errors.has('first_name') }"
            >
              <label>{{ $t('Bao.first_name') }}</label>
              <input
                v-model="creditCardForm.first_name"
                v-validate="'required'"
                type="text"
                name="first_name"
                placeholder="田中"
              >
              <div v-if="errors.has('first_name')" class="help-block">
                {{ $t('Bao.first_name_error') }}
              </div>
            </div>
            <div
              class="form-input inp-right"
              :class="{ 'form-input-error-1': errors.has('last_name') }"
            >
              <label>{{ $t('Bao.last_name') }}</label>
              <input
                v-model="creditCardForm.last_name"
                v-validate="'required'"
                name="last_name"
                type="text"
                placeholder="太郎"
              >
              <div v-if="errors.has('last_name')" class="help-block">
                {{ $t('Bao.last_name_error') }}
              </div>
            </div>
          </div>
          <div class="row-half">
            <div class="form-select-2 form-input inp-left">
              <label>{{ $t('Bao.city_name') }}</label>
              <input
                ref="inputCityField"
                readonly=""
                class="select"
                type="text"
                :placeholder="selectedCityName"
                @click="toggleCity"
              >
              <ul ref="dropdownCity" class="select-box" :class="{ active: isShowCity }">
                <li
                  v-for="(item, key) in stateList"
                  :key="key"
                  :class="{ active: item.code === creditCardForm.city }"
                  @click="clickSelectCity(item)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <div
              class="form-input inp-right"
              :class="{ 'form-input-error-1': errors.has('post_code') || zipCodeError }"
            >
              <label>{{ $t('Bao.post_code') }}</label>
              <input
                v-model="creditCardForm.zip_code"
                v-validate="'required'"
                name="post_code"
                type="text"
                placeholder="000-0000"
                maxlength="8"
                @input="formatZipCode"
              >
              <div v-if="errors.has('post_code')" class="help-block">
                {{ $t('Bao.post_code_error') }}
              </div>
              <div v-else-if="zipCodeError" class="help-block">
                {{ zipCodeError }}
              </div>
            </div>
          </div>
          <div
            class="form-input"
            :class="{ 'form-input-error-1': errors.has('address_name') }"
          >
            <label>{{ $t('Bao.address_name') }}</label>
            <input
              v-model="creditCardForm.address"
              v-validate="'required'"
              name="address_name"
              type="text"
              :placeholder="$t('Bao.address_name_notice')"
              @input="formatAddress"
            >
            <div v-if="errors.has('address_name')" class="help-block">
              {{ $t('Bao.address_name_error') }}
            </div>
          </div>
          <div
            class="form-input row-half phone-input-form"
            :class="{ 'form-input-error-1': phoneError && phoneError !== $t('Bao.phone_available')}"
          >
            <label>{{ $t('Bao.cell_phone') }}</label>
            <div class="phone-input-frame">
              <input
                class="inp-left"
                type="text"
                value="+81"
                readonly
              >
              <input
                v-model="creditCardForm.cell_phone"
                v-validate="'required'"
                class="inp-right"
                name="cell_phone"
                type="text"
                placeholder="09024041901"
                @input="phonecheck"
              >
              <div v-if="phoneError === $t('Bao.phone_available')" class="account_good">
                {{ phoneError }}
              </div>
              <div v-else-if="phoneError" class="help-block">
                {{ phoneError }}
              </div>
            </div>
          </div>
          <div
            class="form-input"
            :class="{ 'form-input-error-1': errors.has('credit_email_check') }"
          >
            <label>{{ $t('Bao.email') }}</label>
            <input
              v-model="creditCardForm.email"
              v-validate="'required'"
              name="credit_email_check"
              type="email"
              :placeholder="$t('Bao.email_notice')"
            >
            <div v-if="errors.has('credit_email_check')" class="help-block">
              {{ $t('Bao.email_check_error') }}
            </div>
          </div>
          <div
            class="form-input"
            :class="{ 'form-input-error-1': errors.has('credit_card_number') || creditCardNumberError}"
          >
            <label>{{ $t('Bao.credit_card_number') }}</label>
            <input
              v-model="creditCardForm.credit_card_number"
              v-validate="'required'"
              type="text"
              name="credit_card_number"
              maxlength="19"
              placeholder="8888-8888-8888-8888"
              @input="formatCreditCardNumber"
            >
            <div v-if="errors.has('credit_card_number')" class="help-block">
              {{ $t('Bao.credit_card_number_error') }}
            </div>
            <div v-else-if="creditCardNumberError" class="help-block">
              {{ creditCardNumberError }}
            </div>
          </div>
          <div class="row-half">
            <div
              class="form-input inp-left"
              :class="{ 'form-input-error-1': errors.has('credit_card_name')}"
            >
              <label>{{ $t('Bao.credit_card_name') }}</label>
              <input
                v-model="creditCardForm.card_printed_name"
                v-validate="'required'"
                type="text"
                name="credit_card_name"
                placeholder="TANAKA TARO"
              >
              <div v-if="errors.has('credit_card_name')" class="help-block">
                {{ $t('Bao.credit_card_name_error') }}
              </div>
            </div>
            <div
              class="form-input inp-right"
              :class="{ 'form-input-error-1': errors.has('credit_card_date') || creditCardDateError}"
            >
              <label>{{ $t('Bao.credit_card_date') }}</label>
              <input
                v-model="creditCardDate"
                v-validate="'required'"
                type="text"
                name="credit_card_date"
                maxlength="5"
                placeholder="MM/YY"
                @input="formatCreditCardDate"
                @blur="handleDateBlur"
              >
              <div v-if="errors.has('credit_card_date')" class="help-block">
                {{ $t('Bao.credit_card_date_error') }}
              </div>
              <div v-else-if="creditCardDateError" class="help-block">
                {{ creditCardDateError }}
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="form-input">
            <label>{{ $t('Bao.bank_id') }}</label>
            <div class="form-select-2">
              <input
                :disabled="!selectedBankName"
                readonly=""
                class="select"
                type="text"
                :placeholder="selectedBankName"
                @click="toggleBank"
              >
              <ul class="select-box" :class="{ active: isShowBankName }">
                <li
                  v-for="(item, key) in allBank"
                  :key="key"
                  :class="{ active: item.id === form.bank_id }"
                  @click="clickSelectBank(item)"
                >
                  {{ item.bank_name }}
                </li>
              </ul>
            </div>
          </div>
          <div v-if="form.type === 1" class="form-input">
            <label>{{ $t('Bao.branch_name') }}：</label>
            <input
              v-model="form.branch_name"
              v-validate="'required'"
              name="branch_name"
              type="text"
              :data-vv-as="$t('Bao.branch_name')"
              :placeholder="$t('Bao.branch_name')"
            >
            <div v-if="errors.has('branch_name')" class="help-block">
              {{ $t('Bao.branch_name_no_blank') }}
            </div>
          </div>
          <div v-if="form.type === 1" class="form-input">
            <label>{{ $t('Bao.branch_code') }}</label>
            <input
              v-model="form.branch_code"
              v-validate="'required|integer'"
              name="branch_code"
              type="text"
              pattern="[0-9]*"
              :data-vv-as="$t('Bao.branch_code')"
              :placeholder="$t('Bao.branch_code')"
            >
            <div v-if="errors.has('branch_code')" class="help-block">
              {{ $t('Bao.branch_code_no_blank') }}
            </div>
          </div>
          <div class="form-input">
            <label>{{ $t('Bao.bank_account_name') }}</label>
            <input
              v-model="form.account_name"
              v-validate="'required'"
              name="account_name"
              type="text"
              :data-vv-as="$t('Bao.bank_account_name')"
              :placeholder="$t('Bao.bank_account_placeholder')"
              @input="validateKatakana('account_name')"
            >
            <div v-if="errors.has('account_name')" class="help-block">
              {{ $t('Bao.bank_account_name_error') }}
            </div>
            <div v-else-if="accNameError" class="help-block">
              {{ $t('Bao.katakana_only') }}
            </div>
          </div>
          <div class="form-input">
            <label>{{ labelText }}</label>
            <input
              v-model="form.card_number"
              v-validate="'required'"
              name="card_number"
              type="text"
              :data-vv-as="labelText"
              :placeholder="labelText"
            >
            <div v-if="errors.has('card_number')" class="help-block">
              {{ errorMessage }}
            </div>
          </div>
          <div class="form-input">
            <label>{{ confirmLabelText }}</label>
            <input
              ref="card_number"
              v-model="form.confirm_card_number"
              v-validate="'required'"
              name="confirm_card_number"
              type="text"
              :data-vv-as="confirmLabelText"
              :placeholder="confirmLabelText"
            >
            <div v-if="confirmCardNumberError" class="help-block">
              {{ confirmErrorMessage }}
            </div>
          </div>
        </template>
      </div>
      <div class="button-wrap">
        <button class="btn btn-tertiary" :disabled="isButtonDisabled" @click="handleSubmit()">
          <span>{{ $t('Bao.confirm_btn') }}</span>
        </button>
        <button class="btn btn-tertiary" @click="$router.push('/user/bank')">
          <span>{{ $t('Bao.cancel') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { phoneCheck } from '@/api/user'
import { showNotice, setErrorMessage } from '@/utils/tool'
import { createBankCard, getAllBankByCurrency, createCreditCard, getStateCode } from '@/api/bank'
import '@/assets/css/bank-card.css'

export default {
  data() {
    return {
      allBank: [],
      isShowType: false,
      isShowCity: false,
      selectedType: this.$t('Bao.card'),
      isShowBankName: false,
      selectedBankName: '',
      selectedCityName: '',
      confirmCardNumberError: false,
      form: {
        type: 1,
        bank_id: null,
        card_number: null,
        confirm_card_number: null,
        account_name: null,
        branch_name: null,
        branch_code: null
      },
      // 信用卡所需資訊
      creditCardForm: {
        name: '',
        first_name: null,
        last_name: null,
        address: null,
        city: null,
        state: null,
        zip_code: null,
        country: 'JP',
        phone: null,
        cell_phone: null,
        email: null,
        credit_card_number: null,
        card_printed_name: null,
        expire_month: null,
        expire_year: null
      },
      stateList: [],
      phoneError: '',
      zipCodeError: '',
      creditCardDate: null,
      creditCardDateError: '',
      creditCardNumberError: '',
      isPhoneValid: false,
      isZipCodeValid: true,
      isCreditCardDateValid: false,
      isCreditCardNumberValid: true,
      accNameError: false
    }
  },
  computed: {
    labelText() {
      return this.form.type === 1 ? this.$t('Bao.card_number') : this.$t('Bao.wallet_address')
    },
    confirmLabelText() {
      return this.form.type === 1 ? this.$t('Bao.confirm_card_number') : this.$t('Bao.confirm_wallet_address')
    },
    errorMessage() {
      return this.form.type === 1 ? this.$t('Bao.bank_card_number_error') : this.$t('Bao.wallet_address_error')
    },
    confirmErrorMessage() {
      return this.form.type === 1 ? this.$t('Bao.confirm_card_number_different') : this.$t('Bao.confirm_wallet_address_different')
    },
    isButtonDisabled() {
      const hasErrors = this.errors.any()
      if (this.form.type === 1) {
        const hasEmptyFields = Object.values(this.form).some(value => value === null || value === '')
        return !this.selectedBankName || hasErrors || hasEmptyFields || this.confirmCardNumberError
      } else if (this.form.type === 4) {
        /* eslint-disable no-unused-vars */
        const { name, state, phone, cell_phone, expire_month, expire_year, ...formToCheck } = this.creditCardForm
        const hasEmptyFields = Object.values(formToCheck).some(value => value === null || value === '')

        return hasErrors || hasEmptyFields ||
          !this.isPhoneValid || !this.isZipCodeValid ||
          !this.isCreditCardDateValid || !this.isCreditCardNumberValid || this.accNameError
      } else {
        /* eslint-disable no-unused-vars */
        const { branch_name, branch_code, ...formToCheck } = this.form
        const hasEmptyFields = Object.values(formToCheck).some(value => value === null || value === '')
        return !this.selectedBankName || hasErrors || hasEmptyFields || this.confirmCardNumberError
      }
    }
  },
  watch: {
    'form.confirm_card_number': function(newVal) {
      this.checkConfirmCardNumber()
    },
    'form.card_number': function() {
      this.checkConfirmCardNumber()
    }
  },
  created() {
    this.getAllBank()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
    document.removeEventListener('click', this.handleClickCityOutside)
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    document.addEventListener('click', this.handleClickCityOutside)
    const selectType = this.$route.query.selectType
    if (selectType) {
      this.clickSelectType(parseInt(selectType, 10))
    }
  },
  methods: {
    checkConfirmCardNumber() {
      if (this.form.card_number !== this.form.confirm_card_number) {
        this.confirmCardNumberError = true
      } else {
        this.confirmCardNumberError = false
      }
    },
    handleClickOutside(event) {
      const dropdown = this.$refs.dropdown
      const inputField = this.$refs.inputField

      if (dropdown && !dropdown.contains(event.target) &&
        inputField && !inputField.contains(event.target)) {
        this.isShowType = false
      }
    },
    handleClickCityOutside(event) {
      const dropdownCity = this.$refs.dropdownCity
      const inputCityField = this.$refs.inputCityField

      if (dropdownCity && !dropdownCity.contains(event.target) &&
        inputCityField && !inputCityField.contains(event.target)) {
        this.isShowCity = false
      }
    },
    debounce: function(func, wait) {
      let timeout
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout)
          func(...args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
      }
    },
    phonecheck() {
      if (!this.creditCardForm.cell_phone) {
        this.phoneError = this.$t('Bao.phone_error')
        this.isPhoneValid = false
      } else {
        this.debounceCheckPhone()
      }
    },
    phoneApiCall() {
      const originalPhone = this.creditCardForm.cell_phone
      const formattedPhone = '+81' + this.creditCardForm.cell_phone
      if (this.creditCardForm.cell_phone && this.creditCardForm.cell_phone.trim() !== '') {
        phoneCheck({ phone: formattedPhone }).then(res => {
          this.creditCardForm.phone = originalPhone
          this.creditCardForm.cell_phone = originalPhone
          this.phoneError = this.$t('Bao.phone_available')
          this.isPhoneValid = true
        }).catch(err => {
          console.error(err)
          this.creditCardForm.phone = originalPhone
          this.creditCardForm.cell_phone = originalPhone
          this.phoneError = this.$t('Bao.phone_error')
          this.isPhoneValid = false
        })
      }
    },
    clickSelectType(type) {
      this.form.type = type
      this.isShowType = false

      if (type === 4) {
        this.selectedType = this.$t('Bao.credit_card')
        this.debounceCheckPhone = this.debounce(this.phoneApiCall, 500)

        getStateCode({ country: 'JP' })
          .then((response) => {
            this.stateList = response.data.data
            this.selectedCityName = this.stateList[0].name
            this.creditCardForm.city = this.stateList[0].code
            this.creditCardForm.state = this.creditCardForm.city
          })
          .catch((error) => {
            console.error('Error:', error)
          })
      } else {
        this.getAllBank()
      }

      if (type === 1) {
        this.selectedType = this.$t('Bao.card')
      } else if (type === 2) {
        this.selectedType = this.$t('Bao.e_wallet')
      } else if (type === 3) {
        this.selectedType = this.$t('Bao.cryptocurrency')
      }
    },
    clickSelectBank(item) {
      this.isShowBankName = false
      this.selectedBankName = item.bank_name
      this.form.bank_id = item.id
    },
    clickSelectCity(item) {
      const code = item.code
      this.creditCardForm.city = code
      this.creditCardForm.state = code
      this.selectedCityName = item.name
      this.isShowCity = !this.isShowCity
    },
    getAllBank() {
      getAllBankByCurrency(this.form.type).then((response) => {
        this.allBank = response.data.data
        if (this.allBank.length !== 0) {
          this.selectedBankName = this.allBank[0].bank_name
          this.form.bank_id = this.allBank[0].id
        } else {
          this.selectedBankName = ''
        }
      })
    },
    handleSubmit() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          if (this.form.type === 4) {
            const originalPhone = this.creditCardForm.cell_phone
            const formattedPhone = '+81' + this.creditCardForm.cell_phone
            this.creditCardForm.phone = formattedPhone
            this.creditCardForm.cell_phone = formattedPhone

            createCreditCard(this.creditCardForm).then((response) => {
              showNotice(response.data.data.message)
              this.$router.push({ path: '/user/bank' }).catch(() => {})
            }).catch(error => {
              this.creditCardForm.phone = originalPhone
              this.creditCardForm.cell_phone = originalPhone
              setErrorMessage(error.response, this.errors)
            })
          } else {
            createBankCard(this.form).then((response) => {
              showNotice(response.data.msg)
              this.$router.push({ path: '/user/bank' }).catch(() => {})
            }).catch(error => {
              setErrorMessage(error.response, this.errors)
            })
          }
        }
      })
    },
    toggleCardType() {
      this.isShowType = !this.isShowType
      this.isShowBankName = false
      this.isShowCity = false
    },
    toggleBank() {
      this.isShowBankName = !this.isShowBankName
      this.isShowType = false
      this.isShowCity = false
    },
    toggleCity() {
      this.isShowCity = !this.isShowCity
      this.isShowBankName = false
      this.isShowType = false
    },
    formatAddress() {
      this.creditCardForm.address = this.creditCardForm.address.replace(/[^a-zA-Z0-9\s]/g, '')
    },
    formatZipCode() {
      const digits = this.creditCardForm.zip_code.replace(/\D/g, '')
      this.creditCardForm.zip_code = digits.replace(/(\d{3})(\d{1,4})/, '$1-$2')
      this.validateZipCode()
    },
    validateZipCode() {
      if (!this.creditCardForm.zip_code) {
        return
      }

      const rawNumber = this.creditCardForm.zip_code.replace(/-/g, '')
      if (rawNumber.length !== 7 || !/^\d{7}$/.test(rawNumber)) {
        this.zipCodeError = this.$t('Bao.post_code_error')
        this.isZipCodeValid = false
      } else {
        this.zipCodeError = ''
        this.isZipCodeValid = true
      }
    },
    formatCreditCardDate() {
      const input = this.creditCardDate.replace(/\D/g, '')
      this.creditCardDate = input
      this.creditCardDateError = ''
      this.isCreditCardDateValid = true
    },
    handleDateBlur() {
      if (!this.creditCardDate) {
        return
      }

      let input = this.creditCardDate.replace(/\D/g, '')

      if (input.length === 3 && /^[1-9]/.test(input)) {
        input = '0' + input
        this.creditCardDate = `${input.slice(0, 2)}/${input.slice(2, 4)}`
      }

      if (input.length === 4) {
        const month = parseInt(input.slice(0, 2), 10)
        const year = parseInt(input.slice(2, 4), 10)
        if (month < 1 || month > 12) {
          this.creditCardDateError = this.$t('Bao.credit_card_date_error')
          this.isCreditCardDateValid = false
          return
        }

        const currentDate = new Date()
        const currentYear = currentDate.getFullYear()
        const currentMonth = currentDate.getMonth() + 1
        const expYear = parseInt(`20${year}`)
        const expMonth = parseInt(month)

        if (expYear < currentYear || (expYear === currentYear && expMonth < currentMonth)) {
          this.creditCardDateError = this.$t('Bao.credit_card_date_error')
          this.isCreditCardDateValid = false
          return
        }

        this.creditCardDate = `${input.slice(0, 2)}/${input.slice(2, 4)}`
        this.creditCardForm.expire_month = input.slice(0, 2)
        this.creditCardForm.expire_year = expYear
        this.creditCardDateError = ''
        this.isCreditCardDateValid = true
      } else {
        this.creditCardDateError = this.$t('Bao.credit_card_date_error')
        this.isCreditCardDateValid = false
      }
    },
    formatCreditCardNumber() {
      const digits = this.creditCardForm.credit_card_number.replace(/\D/g, '')
      this.creditCardForm.credit_card_number = digits.replace(/(\d{4})(?=\d)/g, '$1-')
      this.validateCreditCardNumber()
    },
    validateCreditCardNumber() {
      if (!this.creditCardForm.credit_card_number) {
        return
      }

      const rawNumber = this.creditCardForm.credit_card_number.replace(/-/g, '')
      if (rawNumber.length !== 16 || !/^\d{16}$/.test(rawNumber)) {
        this.creditCardNumberError = this.$t('Bao.credit_card_number_error')
        this.isCreditCardNumberValid = false
      } else {
        this.creditCardNumberError = ''
        this.isCreditCardNumberValid = true
      }
    },
    validateKatakana(field) {
      // 片假名的正則表達式
      const katakanaRegex = /^[ァ-ヶー]*$/

      if (field === 'account_name') {
        if (!katakanaRegex.test(this.form.account_name)) {
          this.accNameError = true
        } else {
          this.accNameError = false
        }
      }
    }
  }
}
</script>

<style scoped>
.account_good {
  color: rgb(27, 185, 27);
  font-size: 12px;
  line-height: 1;
  margin-left: auto;
  margin-top: 5px;
}

.form-input.form-input-error-1 input:not(.inp-left) {
  border: 1px solid #FF0000;
}
</style>
